import React from "react";
import { Badge } from "flowbite-react";
import type { ArticlePublicationStatus } from "@/domains/articles/Article";

/**
 * 開発サーバーで、本番ではまだ表示されない記事を見分けるためのバッジ
 */
export const ArticlePublicationBadge: React.FC<{
  status: ArticlePublicationStatus;
}> = ({ status }) => {
  switch (status) {
    case "draft":
      return <Badge color="warning">下書き</Badge>;
    case "scheduled":
      return <Badge color="info">公開予定</Badge>;
    case "public":
      return null;
  }
};
